export enum DiscountApplicationTypeEnum {
  COMPETITIVE = 'COMPETITIVE',
  CUMULATIVE = 'CUMULATIVE',
}
